export default "__VITE_ASSET__35079eee__"